export enum ContentsType {
    CycleDate = 1,
    FollowupDate = 2
}

export interface TypedContents {
    Type: ContentsType;
}

export interface CycleDateContents extends TypedContents {
    Type: ContentsType.CycleDate;
    PreviousStartDate?: Date;
    PreviousDueDate?: Date;
    NewStartDate?: Date;
    NewDueDate?: Date;
}

export interface FollowupDateContents extends TypedContents {
    Type: ContentsType.FollowupDate;
    PreviousFollowupDueDate?: Date;
    NewFollowupDueDate?: Date;
}

export type Contents = CycleDateContents | FollowupDateContents;
